import { render, staticRenderFns } from "./ReferralLink.vue?vue&type=template&id=3bc46faf&scoped=true"
import script from "./ReferralLink.vue?vue&type=script&lang=js"
export * from "./ReferralLink.vue?vue&type=script&lang=js"
import style0 from "./ReferralLink.vue?vue&type=style&index=0&id=3bc46faf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc46faf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc46faf')) {
      api.createRecord('3bc46faf', component.options)
    } else {
      api.reload('3bc46faf', component.options)
    }
    module.hot.accept("./ReferralLink.vue?vue&type=template&id=3bc46faf&scoped=true", function () {
      api.rerender('3bc46faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralLink/ReferralLink.vue"
export default component.exports